import CaseText from './case-text';
import CaseImage from './case-image';
import CaseVideo from './case-video';
import CaseStory from './case-story';
import CaseButton from './case-button';
import CaseAwards from './case-awards';
import MediaItem from './media-items/media-item';
import * as typeCase from '@/utils/case-types';

export default class Case {
  constructor(data) {
    this.lead = null;
    this.tags = [];
    this.items = [];
    this.client = null;
    this.name = null;
    this.slug = null;
    this.seo = null;
    this.image = [];
    this.mobileimage = [];
    this.businessArea = [];
    this.skills = [];

    // Initialize data
    if (data) {
      Object.assign(this, {
        lead: data.Lead,
        tags: data.TagList,
        items: Case.setItemCase(data),
        client: data.Client,
        image: new MediaItem(data.Image),
        mobileimage: new MediaItem(data.MobileImage),
        name: data.Name,
        slug: data.Slug,
        seo: data.SEO,
        businessArea: data.BusinessArea,
        skills: data.Skills
      });
    }
  }

  static setItemCase(data) {
    const ItemsCase = [];
    if (data.Items) {
      data.Items.forEach((element) => {
        const itemType = element.Type.Id;
        switch (itemType) {
          case typeCase.TYPE_TEXT:
            ItemsCase.push(new CaseText(element));
            break;
          case typeCase.TYPE_IMAGE:
            ItemsCase.push(new CaseImage(element));
            break;
          case typeCase.TYPE_VIDEO:
            ItemsCase.push(new CaseVideo(element));
            break;
          case typeCase.TYPE_STORY:
            ItemsCase.push(new CaseStory(element));
            break;
          case typeCase.TYPE_AWARDS:
            ItemsCase.push(new CaseAwards(element));
            break;
          case typeCase.TYPE_BUTTONLIST:
            ItemsCase.push(new CaseButton(element));
            break;
          default:
            break;
        }
      });

      return ItemsCase;
    }
    return [];
  }
}



// WEBPACK FOOTER //
// src/entities/case/case.js